import { ChevronRight, RotateCcw } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import type { ContinueOption } from '../positionOptions';

interface ContinueCardProps {
  item: ContinueOption;
  brandColor: string;
  /**
   * Provided only in the multi-interview layout, where each card carries its
   * own action. With one interview the primary CTA below the list does the
   * continuing, so the card stays a plain row with a chevron affordance.
   */
  onContinue?: () => void;
}

export function ContinueCard({ item, brandColor, onContinue }: ContinueCardProps) {
  const { t } = useTranslation('applyJob');

  return (
    <div
      className="flex items-center gap-3 rounded-xl border-[1.5px] p-3.5"
      style={{ borderColor: brandColor, background: `${brandColor}0b` }}
    >
      <span
        className="flex size-9 shrink-0 items-center justify-center rounded-full"
        style={{ background: `${brandColor}18` }}
      >
        <RotateCcw className="size-4" style={{ color: brandColor }} aria-hidden />
      </span>
      <div className="min-w-0 flex-1">
        <div className="text-[15px] font-bold leading-tight text-[#16171a]">
          {item.label}
        </div>
        <div className="mt-0.5 truncate text-xs text-[#6b7078]">
          {t('continue_gate_card_sub')}
        </div>
      </div>
      {onContinue ? (
        <button
          type="button"
          onClick={onContinue}
          aria-label={`${t('continue_button')} — ${item.label}`}
          className="h-9 shrink-0 whitespace-nowrap rounded-lg px-3.5 text-sm font-bold text-white"
          style={{ background: brandColor }}
        >
          {t('continue_button')}
        </button>
      ) : (
        <ChevronRight
          className="size-4 shrink-0"
          style={{ color: brandColor }}
          aria-hidden
        />
      )}
    </div>
  );
}
